<template>
  <v-card style="border-radius:15px" class="pa-6 pt-8" height="500px">
      <v-btn text width="15%" class="mb-2" @click="close()"><v-icon>mdi-chevron-left</v-icon>Back</v-btn>
        <h2 class="mb-4">Add Bank Account</h2>
        <v-form>
          <v-select
            style="height:80px"
            color="#e00000"
            outlined
            :items="banks"
            label="Select your bank"
            v-model="bank"
            item-value="code"
            item-text="name"
          />
          <v-text-field
            style="height:80px"
            type="number"
            color="#e00000"
            outlined
            label="Enter your account number"
            v-model="accountNumber"
            @keyup="checkBank()"
          />
          <label>Account Name</label>
          <v-text-field
            style="height:100px"
            v-model="accountName"
            solo
            readonly
          />
        </v-form>
        <v-btn
          @click="addBank()"
          style="float:right;border-radius:8px"
          class="white--text"
          color="#e00000"
          :style="{opacity:opacity}"
          x-large
          >Add Bank</v-btn
        >
      <v-dialog v-model="success" max-width="500">
        <v-card elevation="24" class="createAccount pa-7 text-center">
          <v-icon size="100px" color="white">mdi-check-circle</v-icon>
          <h1
            style="font-size:23px;padding:10px;color:white"
            class="font-weight-black"
          >
            {{ title }}
          </h1>
          <p style="font-size:15px;color:white">{{ message }}</p>
          <v-btn @click="done()" elevation="24"> Ok</v-btn>
        </v-card>
      </v-dialog>

      <v-overlay :absolute="absolute" opacity="0.7" :value="loading">
        <v-progress-circular
          :size="100"
          :width="10"
          color="#e00000"
          indeterminate
        ></v-progress-circular>
        <p class="text-center">Resolving Bank</p>
      </v-overlay>
      <v-overlay :absolute="absolute" opacity="0.7" :value="loadingAddBank">
        <v-progress-circular
          :size="100"
          :width="10"
          color="#e00000"
          indeterminate
        ></v-progress-circular>
        <p class="text-center">Adding Bank</p>
      </v-overlay>

      <v-dialog v-model="error" max-width="500">
        <v-card elevation="24" color="#e00000" class="pa-7 text-center">
          <v-icon size="100px" color="white">mdi-close-circle</v-icon>
          <h1
            style="font-size:23px;padding:10px;color:white"
            class="font-weight-black"
          >
            {{ title }}
          </h1>
          <p style="font-size:15px;color:white">
            {{ message }}
          </p>
          <v-btn @click="error = false" elevation="24"> Close</v-btn>
        </v-card>
      </v-dialog>
  
  </v-card>
</template>

<script>
import axios from "axios";
import db from "../db";
import { doc, updateDoc, arrayUnion } from "firebase/firestore";
export default {
  name: "Bank",
  data() {
    return {
      accountNumber: "",
      bank: "",
      accountName: "",
      loading: false,
      absolute: true,
      loadingAddBank: false,
      success: false,
      error: false,
      message: "",
      step: 1,
      opacity:0.5,
      title: "",
      banks: [
        { id: "1", name: "Access Bank", code: "044" },
        { id: "2", name: "Citibank", code: "023" },
        { id: "3", name: "Diamond Bank", code: "063" },
        { id: "4", name: "Dynamic Standard Bank", code: "" },
        { id: "5", name: "Ecobank Nigeria", code: "050" },
        { id: "6", name: "Fidelity Bank Nigeria", code: "070" },
        { id: "7", name: "First Bank of Nigeria", code: "011" },
        { id: "8", name: "First City Monument Bank", code: "214" },
        { id: "9", name: "Guaranty Trust Bank", code: "058" },
        { id: "10", name: "Heritage Bank Plc", code: "030" },
        { id: "11", name: "Jaiz Bank", code: "301" },
        { id: "12", name: "Keystone Bank Limited", code: "082" },
        { id: "13", name: "Kuda Bank", code: "611" },
        { id: "14", name: "Providus Bank Plc", code: "101" },
        { id: "15", name: "Polaris Bank", code: "076" },
        { id: "16", name: "Stanbic IBTC Bank Nigeria Limited", code: "221" },
        { id: "17", name: "Standard Chartered Bank", code: "068" },
        { id: "18", name: "Sterling Bank", code: "232" },
        { id: "19", name: "Suntrust Bank Nigeria Limited", code: "100" },
        { id: "20", name: "Union Bank of Nigeria", code: "032" },
        { id: "21", name: "United Bank for Africa", code: "033" },
        { id: "22", name: "Unity Bank Plc", code: "215" },
        { id: "23", name: "Wema Bank", code: "035" },
        { id: "24", name: "Zenith Bank", code: "057" },
      ],
    };
  },

  props: {
    bankDetails: {
      type: Array,
    },
  },

  computed: {
    bankName() {
      return this.banks.filter((bank) => bank.code == this.bank)[0].name;
    },
  },

  methods: {
    checkBank() {
      if (this.accountNumber.length == 10) {
        this.resolveBank();
      }
    },

    resolveBank() {
      this.opacity = 1
      this.loading = true;
     axios({
        method: "post",
        url: "https://tips-api.herokuapp.com/bank",
        data:{
          accountNumber:this.accountNumber,
          bank:this.bank
        }
      }).then((response) => {
          if(response.data.data == null){
        this.$swal({
          title: "Bank Account not found",
          text: "Please check your account number and try again",
          icon: "error",
          button: "Try again",
        })
        this.loading = false
        }
        else{
        this.accountName = response.data.data.account_name;
        this.loading = false
        }
      
      })
    },

    async addBank() {
    if(this.accountNumber != '' && this.accountName != '' && this.bankName != ''){
      this.loadingAddBank = true;
      let payLoad = {
        accountNumber: this.accountNumber,
        accountName: this.accountName,
        bankname: this.bankName,
        bank: this.bank,
      };
       const user = doc(db, "users", localStorage.getItem("tippingsKey"))
       await updateDoc(user, {
       'bank': arrayUnion(payLoad)
       })
        .then(() => {
          this.loadingAddBank = false;
          this.success = true;
          this.title = "Bank Account Added Successfully!";
          this.message =
            "Your bank details have successfully been added to your Tippings account for withdrawal purposes";
        })
        .catch((error) => {
          console.log(error.message);
          this.loadingAddBank = false;
          this.error = true;
          this.title = "Something went wrong!";
          this.message =
            "Sorry, we were not able to add your bank to your Tippings account";
        });
    }
    },

    done() {
      this.success = false;
      this.error = false;
      location.reload();
    },

    close(){
        this.$emit('close')
    }
  },
};
</script>



<style>

.createAccount {
  background: linear-gradient(180deg, #e00000 0%,red 100%);
}

</style>
